// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__WK1Nn","tooltipContent":"styles_tooltipContent__h7YSP","tooltipItem":"styles_tooltipItem___pa04"};